const malfunctionsReducerDefaultState = {
    hasErrored: false,
    isLoading: false,
    malfunctions: [],
    token: ''
};

export default (state = malfunctionsReducerDefaultState, action) => {
    switch (action.type) {
        case 'MALFUNCTIONS_HAS_ERRORED':
            return {
                ...state,
                hasErrored: action.hasErrored,
                isLoading: action.isLoading

            };

        case 'MALFUNCTIONS_IS_LOADING':
            return {
                ...state,
                isLoading: action.isLoading
            };

        case 'MALFUNCTIONS_FETCH_LIST_SUCCESS':
            return {
                ...state,
                malfunctions: action.malfunctions,
                isLoading: action.isLoading,
            };

        case 'SET_TOKEN':
            return {
                ...state,
                token: action.token
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/malfunctions.js